import './index.scss'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import {
  faBriefcase,
  faEnvelope,
  faFileLines,
  faHome,
  faLaptopCode,
  faScrewdriverWrench,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, NavLink } from 'react-router-dom'

import LogoS from '../../assets/images/omar-monogram.svg'
import { profile } from '../../data/portfolio'


const Sidebar = () => {
  return (
    <>
      <div className="nav-bar">
        <Link className="logo" aria-label="Home" to="/">
          <img src={LogoS} alt="Logo" />
          <span className="sidebar-name">Omar</span>
        </Link>
        <nav>
          <NavLink exact="true" activeclassname="active" aria-label="Home" to="/">
            <FontAwesomeIcon icon={faHome} color="#5f605a" />
          </NavLink>
          <NavLink activeclassname="active" className="about-link" aria-label="About" to="/about">
            <FontAwesomeIcon icon={faUser} color="#5f605a" />
          </NavLink>

          <NavLink
            activeclassname="active"
            className="experience-link"
            aria-label="Experience" to="/experience"
          >
            <FontAwesomeIcon icon={faBriefcase} color="#5f605a" />
          </NavLink>

          <NavLink
            activeclassname="active"
            className="projects-link"
            aria-label="Projects" to="/projects"
          >
            <FontAwesomeIcon icon={faLaptopCode} color="#5f605a" />
          </NavLink>

          <NavLink
            activeclassname="active"
            className="skills-link"
            aria-label="Skills" to="/skills"
          >
            <FontAwesomeIcon icon={faScrewdriverWrench} color="#5f605a" />
          </NavLink>

          <NavLink
            activeclassname="active"
            className="contact-link"
            aria-label="Contact" to="/contact"
          >
            <FontAwesomeIcon icon={faEnvelope} color="#5f605a" />
          </NavLink>
          <NavLink className="resume-link" aria-label="Resume" to="/resume"><FontAwesomeIcon icon={faFileLines} color="#5f605a" /></NavLink>
        </nav>
        <ul>
          <li>
            <a
              href={profile.linkedin} aria-label="LinkedIn"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} color="#5f605a" />
            </a>
          </li>
          <li>
            <a
              href={profile.github} aria-label="GitHub"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faGithub} color="#5f605a" />
            </a>
          </li>

        </ul>
      </div>
    </>
  )
}

export default Sidebar
